export default {
    block1 : 'block1',
  }